import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'antd'
import clsx from 'clsx'
import { GoogleRepliesForACase } from '../../../app/api'
import { toRejectionReason } from '../model/types/RejectionReason.type'

interface RejectionReasonLabelProps {
  replyType: GoogleRepliesForACase['reply_type']
  /** У Disappeared причина всегда «Ad not found», цвет — как у тега статуса */
  disappeared?: boolean
}

export const RejectionReasonLabel = ({ replyType, disappeared }: RejectionReasonLabelProps) => {
  const { t } = useTranslation()
  const reason = disappeared ? 'ad_not_found' : toRejectionReason(replyType)

  return (
    <Tooltip
      placement={'bottomLeft'}
      title={t(`pages.trademarkInfringements.rejectionReasons.${reason}.tooltip`)}
    >
      <span
        className={clsx(
          'w-fit cursor-default text-[12px] leading-[16px]',
          disappeared ? 'text-[#557191]' : 'text-[#DA5533]',
        )}
      >
        {t(`pages.trademarkInfringements.rejectionReasons.${reason}.label`)}
      </span>
    </Tooltip>
  )
}
